export default {
  reports: {
    male: "Mwanaume",
    female: "Mwanamke",
    other: "Nyingine",
    farmerName: "Jina la Mkulima",
    farmerProdChart: "Chati ya Uzalishaji wa Mkulima",
    production: "Uzalishaji",
    byProduction: "Kwa Uzalishaji",
    byName: "Kwa Jina",
    descending: "Kushuka",
    ascending: "Kupanda",
    buyingStationProdChart: "Chati ya Uzalishaji wa Kituo cha Kununua",
    buyingStation: "Kituo cha Kununua",
    buyingStationName: "Kununua Jina la Kituo",
    dryMilling: "Kusaga Kavu",
    dryMillingName: "Jina la Dry Milling",
    dryMillingProdChart: "Chati ya Uzalishaji wa Usagishaji Vikavu",
    view: "Tazama",
    date: "Tarehe",
    reports: "Ripoti",
    today: "Leo",
    week: "Wiki",
    month: "Mwezi",
    year: "Mwaka",
    all: "Zote",
    selectCrop: "Chagua Mazao",
    selectRegion: "Chagua Mkoa",
    selectProvinceState: "Chagua Mkoa/Jimbo",
    downloadPdfReport: "Pakua Ripoti ya PDF",
    export: "Eksport",
    search: "Tafuta",
    yield: "Mazao",
    averageSellingPriceByAllFarmers: "Bei ya Kuuza kwa Wakulima Wote",
    averageSellingPricePerFarmer: "Bei ya Kuuza kwa Mkulima Mmoja",
    pricePaid: "Bei Iliyolipwa",
    pests: {
      pestReport: "Ripoti ya Wadudu Wabovu",
      filterByCrops: "Chuja Kwa Mazao",
      pestStatistics: "Takwimu za Wadudu Wabovu",
      regions: "Mikoa",
      occurrences: "Matukio",
      pestChart: "Grafu ya Wadudu Wabovu",
      totalArea: "Jumla ya Eneo",
      pestName: "Jina la Wadudu Wabovu",
      region: "Mkoa",
      crop: "Mazao",
      listByLand: "Orodha Kwa Ardhi",
    },
    regions: {
      regionalReport: "Ripoti ya Kikanda",
      listByFarm: "Orodha kwa Shamba",
      listByFarmers: "Orodha kwa Wakulima",
      listByYield: "Orodha kwa Mazao",
      regionalStatistics: "Takwimu za Kikanda",
      countries: "Nchi",
      states: "Mikoa/Majimbo",
      city: "Mji/Kijiji",
      farmsIn: "Mashamba huko",
      regionalChart: "Grafu ya Kikanda",
      farms: "Mashamba",
      regionName: "Jina la Kanda",
      farmers: "Wakulima",
      yield: "Mazao/Eka",
    },
    dashboard: {
      topCharts: "Majedwali ya Juu",
      regions: "Mikoa",
      noOfFarms: "Idadi ya Mashamba/Kanda",
      provinces: "Mikoa",
      landArea: "Eneo la Ardhi",
      avgFarmerLand: "Eneo la Mkulima Wastani",
      viewAll: "Tazama Yote",
      crops: "Mazao",
      plantedAreaCrop: "Eneo Lililopandwa/Kilimo",
      plantedArea: "Eneo Lililopandwa",
      avgYieldCrop: "Mavuno Wastani/Kilimo",
      averageYield: "Mavuno Wastani",
      yieldChart: "Grafu ya Mavuno",
      selectFarm: "Chagua Shamba",
      soilQuality: "Ubora wa Udongo",
      pests: "Wadudu",
      occurrences: "Matukio",
      equipments: "Vifaa",
      goalAchievedChart: "Chati ya Malengo Yaliyofikiwa",
      soilValues: "Maadili ya Udongo",
      soil: "Maadili",
      showReport: "Onyesha ripoti kwenye Dashibodi",
      selectAll: "Chagua zote",
    },
    avgPrice: "Bei ya Wastani",
    avgPriceFarmer: "Bei ya Wastani Inayolipwa kwa Mkulima (Kakao)",
    byCountry: "Kwa Nchi",
    gen: "Jinsia",
    gender: "Chatu ya Jinsia",
    selectYear: "Chagua Mwaka",
    total: "Jumla",
    unspefied: "Haijabainishwa",
    weight: "Uzito",
    quality: "Ubora",
    price: "Bei",
  },
};
